<template>
    <div>
        <Popup position="bottom" v-model="show2">
            <Picker
                    show-toolbar
                    :title="title"
                    :columns="columns"
                    @confirm="onOk"
                    @cancel="onCancel"
            />
        </Popup>
    </div>
</template>

<script>
    import {Button, Icon, Picker, Popup} from "vant"
    import * as DICT from "@/utils/dict";

    export default {
        props: {
            data: { type: Array, required: true },
            title: {type: String, default: "请选择"},
            block: {type: Boolean, default: false},
            show: {type: Boolean, default: false},
        },
        components: {
            Button,
            Popup,
            Picker,
            Icon
        },
        data() {
            return {
                text: '',
                value: '',
                columns: []
            };
        },
        computed: {
            show2: {
                get() {
                    return this.show
                },
                set() {
                    this.onCancel()
                }
            },
        },
        methods: {
            onCancel() {
                this.$emit('cancel')
            },
            onOk(item) {
                this.$emit("ok", item);
            },
            getResult(data){
                this.columns = data.map(item => {
                    item.text = item.result;
                    return item
                })
            }
        },
        created() {
          this.getResult(this.data)
        },
        watch: {
            data(data){
                this.getResult(data)
            }
        }
    };
</script>

<style lang="less" scoped>
    .btn-content {
        display: flex;
        justify-content: space-around;
        align-items: center;
    }
</style>
